import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {number_format,number_input_format} from '../helper/format';

class Subsidypopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      subsidy_price: 0,
      _subsidy_price: 0
    };
    this.priceTextObj = null;
  }
  Open(_subsidy_price)
  {
    this.setState({
      subsidy_price : _subsidy_price,
      _subsidy_price : _subsidy_price,
      open : true
    });
  }
  ChangePrice()
  {
    if( this.priceTextObj )
    {
      this.setState({
        subsidy_price : this.priceTextObj.value
      });
    }
  }
  applyOriginal()
  {
    var subsidy_price = this.state._subsidy_price;
    this.setState({
      subsidy_price : subsidy_price
    });
  }
  Close()
  {
    this.setState({
      open: false
    })
  }
  Apply()
  {
    this.props.onSubsidyChanged(this.state.subsidy_price);
    this.Close();
  }
  render()
  {
    var self = this;
    return (
      <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
        <div className="modal-dialog modal-md mb0">
          <div className="popupPadding2 pr45">
            <div className="md-popup-header"> &nbsp;공시 지원금 변경</div>
            <div className="md-popup-contents">
              <div>공시 지원금 : {number_input_format(self.state._subsidy_price)} 원 &nbsp;&nbsp;<a href="#apply" onClick={()=>self.applyOriginal()} className="btn btn-default btn-small">적용</a></div>
              <div className="pt15">
                <div className="row">
                  <div className="col-xs-11">
                    <input type="number" ref={(ref)=>{this.priceTextObj = ref}} className="form-control" onChange={()=>{self.ChangePrice()}} value={this.state.subsidy_price}/>
                  </div>
                  <div className="col-xs-1 font18 pl0 pt10">
                    원
                  </div>
                </div>
              </div>
              <div className="pt20 pl18">
                <div className="row font16">
                  변경한 지원금을 적용하시겠습니까?
                </div>
              </div>
              <div className="pt40">
                <div className="row text-center">
                  <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-lg btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-lg btn-select2">취소</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default Subsidypopup;
